// extracted by mini-css-extract-plugin
export var wordContainer = "_rv-0";